export default "__VITE_ASSET__37d9397a__"